






















































/* eslint-disable */
import { Component, Emit, Vue } from 'vue-property-decorator'

import ApiPlans from '@finx/web-repository/src/apis/Plans/Plans'
import PagamentoStore from '@finx/web-repository/src/stores/Pagamento'
import AssinaturaStore from '@/store/Assinaturas'
import PagamentoStepsStore from '@/store/PagamentoSteps'

const component: Object = {
  store: {
    AssinaturaStore,
    PagamentoStepsStore,
    PagamentoStore,
  },
}

@Component(component)

export default class ComponentPagamentoSteps extends Vue {
  stores: any = {
    assinaturas: (this.$store as any).AssinaturaStore,
    steps: (this.$store as any).PagamentoStepsStore,
    pagamento: (this.$store as any).PagamentoStore,
  }

  alert: any = {
    show: false,
  }

  get acao() {
    return this.stores.pagamento.getters.ACAO
  }

  get assinatura() {
    return this.stores.assinaturas.getters.ASSINATURA
  }

  get stepAtiva() {
    return this.stores.steps.getters.STEP_ATIVA
  }

  set stepAtiva(newValue) {}

  async ativarAssinatura() {
    this.stores.pagamento.commit('LOADING', true)

    const request = await ApiPlans.Assinatura.activeAssinatura(this.assinatura.id)
    const success = request.status

    if (success) {
      this.stores.steps.commit('STEP_ATIVA', 2)
    } else {
      const error = request.data.errors[0]
      this.showErrorAlert(error)
    }

    this.stores.pagamento.commit('LOADING', false)
  }

  async criarAssinatura(token) {
    let assinatura = {
      ...this.assinatura,
      token: token,
    }

    const request = await ApiPlans.Assinatura.createAssinatura(assinatura)
    const success = request.status === 200

    if (success) {
      this.stores.steps.commit('STEP_ATIVA', 2)
    } else {
      const error = request.data.errors[0]
      this.showErrorAlert(error)
    }

    this.stores.pagamento.commit('LOADING', false)
  }

  async createFormaDePagamento(token: String) {
    const body = {
      token
    }
    const request = await ApiPlans.FormasDePagamento.createFormaDePagamento(body)

    if (request.data.hasSuccess) {
      switch (this.acao) {
        case 'alterar': {
          this.stores.steps.commit('STEP_ATIVA', 2)
          this.stores.pagamento.commit('LOADING', false)
        } break

        case 'assinar': {
          this.criarAssinatura(token)
        } break

        case 'ativar': {
          this.ativarAssinatura()
        } break

        case 'regularizar': {
          this.ativarAssinatura()
        } break
      }
    }
  }

  IuguCreatePaymentToken(card) {
    // @ts-ignore
    Iugu.createPaymentToken(card, (response) => {
      if (!response.errors) this.createFormaDePagamento(response.id)
      else this.showErrorAlert('Verifique novamente as informações, caso o problema persista entre em contato no email contato@finxapp.com.br')
    })
  }

  showErrorAlert(error: string): void {
    this.alert.show = true
    this.alert.message = error

    this.stores.pagamento.commit('LOADING', false)
  }

  @Emit('success')
  showSuccessAlert(acao) {
    this.stores.pagamento.commit('LOADING', false)
  }

  submitFormEndereco() {
    this.stores.pagamento.commit('LOADING', false)
    this.showSuccessAlert(this.acao)
  }

  submitFormDadosCadastrais() {
    this.stores.pagamento.commit('LOADING', false)
    this.stores.steps.commit('STEP_ATIVA', 3)
  }

  submitFormPagamento(card) {
    this.IuguCreatePaymentToken(card)
  }
}
